import { getUuidFrom, getIdFrom } from 'zoomforth_codesbane_viewer/lib/id_utils.js';

import {
  getCurrentlyEditingContentItems
} from 'zoomforth_codesbane_editor/reducers/index.js';

import {
  getSubpageForContent,
  getSubpageBySlugOrId,
  getExistentTargetsForAppAction,
  getContentItemByUuid,
  getSectionForContent
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  setCurrentSubpageId,
  goToContent,
  setScrollToTop,
  scrollToSection
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';



export const editTargetForInternalLink = (
  subpageOrId, 
  currentlyChosenSectionId=null, 
  currentlyChosenContentUuid=null
)=>
  (dispatch, getState)=> {
    const subpage = getSubpageBySlugOrId(getState(), subpageOrId);

    if (subpage) {
      dispatch(setCurrentSubpageId(subpage.id));
    }

    // If contentItem exists we are guaranteed section exists
    const { section, contentItem } = getExistentTargetsForAppAction(getState(), { 
      sectionId: currentlyChosenSectionId,
      contentUuid: currentlyChosenContentUuid 
    });

    if (contentItem) {
      dispatch(goToContent(contentItem));

    } else if (section) {
      dispatch(scrollToSection(section));

    } else {
      dispatch(setScrollToTop());

    }

    dispatch({
      type: 'BEGIN_CHOOSE_TARGET_FOR_INTERNAL_LINK',
      sectionId: section ? section.id : null,
      contentUuid: contentItem ? contentItem.uuid : currentlyChosenContentUuid || null
    }); 

  };


export const chooseSectionForInternalLink = (sectionOrId)=>
  ({
    type: 'SET_CHOSEN_SECTION',
    sectionId: sectionOrId ? getIdFrom(sectionOrId) : null
  });

export const chooseContentItemForInternalLink = (contentItemOrUuid)=> 
  (dispatch, getState)=> {
    
    let sectionId = null;
    if (contentItemOrUuid) {
      const contentItem = getContentItemByUuid(getState(), getUuidFrom(contentItemOrUuid));
      if (contentItem) {
        const section = getSectionForContent(getState(), contentItem);
        sectionId = section ? section.id : null;
      }
    }
    
    dispatch({
      type: 'SET_CHOSEN_CONTENT_ITEM',
      contentUuid: contentItemOrUuid ? getUuidFrom(contentItemOrUuid) : null,
      sectionId: sectionId
    });
  }


export const stopEditTargetForInternalLink = ()=>
  ({
    type: 'END_CHOOSE_TARGET_FOR_INTERNAL_LINK'
  });

export const setCurrentSubpageToCurrentlyEditingContentItem = ()=>
  (dispatch, getState)=> {
    const state = getState();
    const contentItem = getCurrentlyEditingContentItems(state)[0];
    const subpage = getSubpageForContent(state, contentItem);

    dispatch(setCurrentSubpageId(subpage.id));
    dispatch(goToContent(contentItem));
  };
